import { Box, Typography } from "@mui/material";
import { textXS } from "../../../../shared/constants";
import { useWiserTheme } from "../../../../hooks/useWiserTheme";
import { getWorkingModelTagColors } from "../../../../shared/theme/wiserThemeHelpers";
import { workingModelTagGroupSx, getWorkingModelChipSx } from "../../style";

interface IProps {
  /**
   * Tek ad ("Remote") ya da BE'nin ürettiği virgülle birleşik ad
   * ("Remote, Hybrid") — pozisyona en fazla 2 çalışma şekli atanabiliyor.
   */
  workingModel: string;
}

export const WorkingModelTag = ({ workingModel }: IProps) => {
  const { darkModeActive } = useWiserTheme();
  const models = workingModel
    .split(",")
    .map((name) => name.trim())
    .filter(Boolean);

  if (models.length === 0) {
    return null;
  }

  return (
    <Box sx={workingModelTagGroupSx}>
      {models.map((model) => {
        const tagColors = getWorkingModelTagColors(model, darkModeActive);
        return (
          <Box key={model} sx={getWorkingModelChipSx(tagColors.bg)}>
            <Typography sx={textXS(500, tagColors.text)}>{model}</Typography>
          </Box>
        );
      })}
    </Box>
  );
};
